import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR
} from './action-types';


export function loginReducer(state = {}, { payload, type }) {
  switch (type) {
    case LOGIN:
      return Object.assign({}, state, {
        loginError: undefined
      });
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        accessToken: payload
      });
    case LOGIN_ERROR:
      return Object.assign({}, state, {
        loginError: payload || { message: 'Error de comunicación con el servidor' }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/core/services/login/reducer.js